var paragraph_default = {
  "fontElementMap": "hl7c-",
  "elementSpacing": "TfvTg",
  "text": "pQuHl TfvTg",
  "child": "kJaSN"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
